import React from "react";
//#region types
import { QuotesFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModelCustomFilters } from "wint-api-client/dist/types";
import { ACTION_SEPARATOR } from "models/propTypes/menuPropTypes";
//#endregion
//#region components
import useQuotesReportFilterDefinition from "./forms/useReportFilterDefinition";
import CustomerQuotesList from "./quotesList";
import TotalByStatusChart from "./widgets/totalByStatus";
import TotalByMonthChart from "./widgets/totalByMonth";
import {
  ChartContextProvider,
  ChartToggle,
  DashboardButtonGroup,
  FilterButton,
  PageLayouts,
  StyledButton,
  ViewPanel,
  WidgetArea,
} from "components/common";
import { Grid } from "@mui/material";
import { useQuotesService } from "serviceHooks";
import useCreateQuotation from "./useCreateQuotation";
import useQuotationPermissions from "./usePemissions";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const QuotesReport: React.FC = () => {
  const quotesService = useQuotesService();
  const {
    filterFormFields: reportFilterDefinition,
    filterQueryStateHandler,
    apiToReportFilterFormatter,
  } = useQuotesReportFilterDefinition();
  const title = LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.Quotes);
  const onCreateQuotation = useCreateQuotation();
  const { canCreateQuotations, canViewQuotations } = useQuotationPermissions();

  const topRightButtons = (
    <DashboardButtonGroup
      buttons={[
        <StyledButton size="sm" onClick={onCreateQuotation} disabled={!canCreateQuotations}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Quotation.ReportCreateQuotation)}
        </StyledButton>,
        ACTION_SEPARATOR,
        <FilterButton />,
      ]}
    />
  );

  return (
    <PageLayouts.DashboardLayout<QuotesFormTypes.Filter>
      entityKey={0}
      hasPermissions={canViewQuotations}
      title={title}
      topRightButtons={topRightButtons}
      filterFields={reportFilterDefinition}
      filterQueryStateHandler={filterQueryStateHandler}
      filterCategory={WintSuperkollAPIModelCustomFilters.FilterCategory.Quotations}
      reportToAPIFilterFormatter={quotesService.reportToAPIFilter}
      apiToReportFilterFormatter={apiToReportFilterFormatter}
    >
      <WidgetArea>
        <ChartContextProvider>
          <ViewPanel
            title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.StatusGraphTitle)}
            appearance="sm"
            gridSize="md"
            isCanvasContent
          >
            <TotalByStatusChart />
          </ViewPanel>
          <ViewPanel
            title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.AmountDistribution)}
            appearance="sm"
            gridSize="md"
            isCanvasContent
            topRightContent={<ChartToggle />}
          >
            <TotalByMonthChart />
          </ViewPanel>
        </ChartContextProvider>
      </WidgetArea>
      <Grid container item>
        <CustomerQuotesList />
      </Grid>
    </PageLayouts.DashboardLayout>
  );
};

export default QuotesReport;
